// THIS FTILE IS UPDATE
import './App.css';
import { Website } from './Website.js';
import { styles } from './Style.js';


function App() {
  return (
    <div style={styles.App}>
      <Website />
    </div>
  );
}

export default App;
